module.exports = __webpack_public_path__ + "static/media/selector.bb58ef64.svg";